/** A typical single operation per currency, so the corridors table compares like with like. */
export const DEFAULT_EXAMPLE_AMOUNTS: Record<string, string> = {
  COP: "100000",
  BRL: "100",
  MXN: "1000",
  ARS: "50000",
  USD: "100",
  USDT: "100",
};

export const FALLBACK_EXAMPLE_AMOUNT = "1000";

export function defaultExampleAmount(currency: string | null | undefined): string {
  return (currency && DEFAULT_EXAMPLE_AMOUNTS[currency]) || FALLBACK_EXAMPLE_AMOUNT;
}
